export const useIsMobile = (): boolean => {
  if (typeof navigator === "undefined") return true;
  const userAgent = navigator?.userAgent ?? "";
  return /iphone|ipad|ipod|android|mobile/i.test(userAgent);
};
